module.exports = __webpack_public_path__ + "img/facebookicon.931f3cf4.svg";